module.exports = __webpack_public_path__ + "img/蒋老师-1.f7458320.png";